import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import TextComponent from "../textComponent/TextComponent";
import styles from "./Dropdown.module.css";

const Dropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(props.value);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  const handleChange = (value) => {
    setSelectedValue(value);
    // Find the selected option object
    const selectedOption = props?.options.find(
      (option) => option.value === value
    );
    if (props?.onChange) {
      props?.onChange(selectedOption); // Pass the whole object back to the parent
    }
  };
  return (
    <div className={`${styles.main_input} ${props?.className}`}>
      {props?.label &&
        <text className={` ${styles.label} ${props?.labelClass} `}>
          {props?.label}
        </text>
      }
      <div
        className={`${styles.input} ${props.DropdownContainer}`}
        style={props.inputStyle}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Select
          value={selectedValue}
          placeholder={props?.placeholder ? props?.placeholder : 'Select'}
          open={isOpen}
          disabled={props?.isDisabled ? true : false}
          suffixIcon={null}
          className={` ${props?.inputClass}  ${styles.inner_input} `}
          dropdownStyle={{
            fontFamily: "Poppins-regular",
            backgroundColor: '#f7f8f9'
          }}

          // defaultValue={"Select role"}
          onChange={handleChange} // Use the new handleChange function
          options={props?.options?.map((option) => ({
            label: option.value,

            value: option.value,
          }))}
        />

        <div
          className={isOpen ? styles.rightIconUp : styles.rightIconDown}
          onClick={props?.onRightIconPress}
        >
          {/* {isOpen ? <IoMdArrowDropup  /> :  */}
          <IoMdArrowDropdown />
          {/* } */}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
